import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import modalsContainerSelector from '../../selectors/modal/ModalsContainerSelector';
import OneWayConfirmationModal from './OneWayConfirmationModal';
import OneWayNavigationOfflineModal from './OneWayNavigationOfflineModal';
import TalviewInitAllocatedTimePassedModal from './TalviewInitAllocatedTimePassedModal';
import SecondScreenDetectedModal from './SecondScreenDetectedModal';
import PciResourceOverlayModal from './PciResourceOverlayModal';

const ModalsContainer = (props) => {
    const {
        shouldRenderOneWayNavigationModals,
        shouldRenderSecondScreenDetectedModal,
        shouldRenderTalviewInitAllocatedTimePassedModal,
        pciResourceOverlayIds,
    } = props;

    return (<React.Fragment>
        { shouldRenderOneWayNavigationModals &&
            <React.Fragment>
                <OneWayConfirmationModal />
                <OneWayNavigationOfflineModal />
            </React.Fragment>
        }

        { shouldRenderSecondScreenDetectedModal && <SecondScreenDetectedModal /> }

        { shouldRenderTalviewInitAllocatedTimePassedModal && <TalviewInitAllocatedTimePassedModal /> }

        { pciResourceOverlayIds.map(id => <PciResourceOverlayModal key={id} contentItemId={id} />) }

    </React.Fragment>);
};

ModalsContainer.propTypes = {
    shouldRenderOneWayNavigationModals: PropTypes.bool.isRequired,
    shouldRenderSecondScreenDetectedModal: PropTypes.bool.isRequired,
    shouldRenderTalviewInitAllocatedTimePassedModal: PropTypes.bool.isRequired,
    pciResourceOverlayIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

const mapStateToProps = state => modalsContainerSelector.selectProps(state);
export default connect(mapStateToProps)(ModalsContainer);
